import BsPage from './index.vue'
export default BsPage